import { render } from "./operator-dialog.vue?vue&type=template&id=0020126f&scoped=true&ts=true"
import script from "./operator-dialog.vue?vue&type=script&lang=ts"
export * from "./operator-dialog.vue?vue&type=script&lang=ts"

import "./operator-dialog.vue?vue&type=style&index=0&id=0020126f&scoped=true&lang=css"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0020126f"]])

export default __exports__